<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>The Actual and the Rational</h1>
<h1 class="bk1">Hegel and Objective Spirit</h1>
<p class="bkau">Jean-François Kervégan</p>
<p class="bkau1">Translated by Daniela Ginsburg and Martin Shuster</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-kervegan-0003.vue?5bf3c7e3